import React, { Component } from "react";

import LoginInput from "../../shared/items/contols/loginInput";

import styles from "./registration.module.scss";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { withRegistration } from "../../shared/containers/containerRegistration";

class RegistrationForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hiddenPassword: true,
    };
  }

  render() {
    const { onHandleChangeStore, registration } = this.props;
    const { hiddenPassword } = this.state;

    return (
      <React.Fragment>
        <div className={styles.registrationInput}>
          <LoginInput name="email" type="text" value={registration.registrationUser.email} handleChangeStore={() => {}} disabled={true} />
        </div>

        <div className={styles.registrationInput}>
          <LoginInput
            name="title"
            type="text"
            store={registration.registrationItems}
            handleChangeStore={onHandleChangeStore}
            placeholder="Ф.И.О."
            errors={registration.errors}
          />
        </div>

        <div className={styles.registrationInput}>
          <LoginInput
            name="password"
            type={hiddenPassword ? "password" : "text"}
            store={registration.registrationItems}
            handleChangeStore={onHandleChangeStore}
            placeholder="Придумайте пароль"
            errors={registration.errors}
          />
          <div className={styles.showPassordIconWraper}>
            <div
              className={styles.showPassordIcon}
              onClick={() => {
                this.setState({ hiddenPassword: !hiddenPassword });
              }}
            >
              {hiddenPassword ? <VisibilityOffIcon fontSize={"small"} /> : <VisibilityIcon fontSize={"small"} />}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRegistration(RegistrationForm);
